import { ComponentPropsWithoutRef, forwardRef } from 'react';

type Props = ComponentPropsWithoutRef<'div'>;

const PopupHeader = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} className="layer_head">
      {children}
    </div>
  );
});

PopupHeader.displayName = 'PopupHeader';

export default PopupHeader;
